<div class="milestone-step-container">
  <dx-scroll-view class="phase-list">
    @for (phase of phases; track $index) {
      @if (phase.title) {
        <div class="display-node-section">
          <div class="display-node-header" (click)="togglePhaseExpansion(phase)">
            <app-svg-icon
              icon="chevron-down"
              [strokeWidth]="2"
              color="var(--color-grey-700)"
              class="expand-icon"
              [class.expanded]="isPhaseExpanded(phase)"
            ></app-svg-icon>
            <app-svg-icon icon="route" color="var(--color-green-500)" class="phase-icon" [size]="20"></app-svg-icon>
            <span class="display-node-title">{{ phase.title }}</span>
          </div>

          <div class="display-node-content" *ngIf="isPhaseExpanded(phase)">
            <dx-sortable
              class="display-node-children-list"
              [data]="phase.milestones || []"
              handle=".drag-handle"
              (onReorder)="onMilestoneReorder(phase, $event)"
              (onAdd)="onMilestoneAdd(phase, $event)"
              (onDragStart)="$event.itemData = phase.milestones[$event.fromIndex]"
              [allowDropInsideItem]="false"
              [allowReordering]="true"
              itemOrientation="vertical"
              group="milestones"
            >
              @for (milestone of phase.milestones || []; track milestone; let idx = $index) {
                <app-setup-milestone-node
                  [milestone]="milestone"
                  [phase]="phase"
                  [phases]="phases"
                  [editing]="true"
                  [validationGroup]="validationGroup"
                  [allowDelete]="true"
                  (onDelete)="onMilestoneDelete(phase, $event)"
                ></app-setup-milestone-node>
              }
            </dx-sortable>

            <div class="create-button-container">
              <app-gpd-button
                i18n-text="@@addMoreMilestones"
                text="Add More Milestones"
                icon="add"
                type="secondary"
                (onClick)="onMilestoneCreate(phase)"
              ></app-gpd-button>
            </div>
          </div>
        </div>
      }
    }
  </dx-scroll-view>

  <dx-validator [adapter]="milestoneAdapterConfig">
    <dxi-validation-rule
      type="custom"
      [validationCallback]="milestoneValidationCallback"
      i18n-message="@@milestoneConfigInvalidValidationMessage"
      message="Milestone configuration is invalid"
      style="display: none"
    ></dxi-validation-rule>
  </dx-validator>
</div>
